// import Image1 from "./../testimonial1.png";
// import Image2 from "./../testimonial2.png";
// import Image3 from "./../testimonial3.png";
import Image4 from "./../testimonial4.png";

export const Data = [
  {
    id: 1,
    image: Image4,
    title: "Sajin Sunny - Platform Architect",
    description:
      "A really good job,especially with the Oracle HCM integration. Your flexibility and problem-solving skills have been crucial in handling the complex use cases",
  },
  {
    id: 2,
    image: Image4,
    title: "Keerthana - Senior Consultant",
    description:
      "I was glad to work alongside you during my tenure. There were wonderful learnings on that path, and I always looked up to you for the skills you exhibited . Thank you again!",
  },
  {
    id: 3,
    image: Image4,
    title: "Feng Tian Shi - Senior Consultant",
    description:
      "You demonstrate the ability to understand complex scenarios quickly, analyze details proactively, and confidently ask thoughtful questions to drive better outcomes.",
  },
];
